import { RepositoryFactory } from '@/repository/RepositoryFactory';
const SageRepository = RepositoryFactory.get('sage')
const CustomerRepository = RepositoryFactory.get('customer')
const DropDownRepository = RepositoryFactory.get('drop_down')
const supplierManufactureRepository = RepositoryFactory.get('supplierManufacture')

export async function updateSageCustomer(customer_data, sector_list) {
    const credit_details = (await CustomerRepository.getCustomerAccountCredit(customer_data.id)).data.data
    const customer_users = (await CustomerRepository.getCustomerUsers(customer_data.id, 1, '', 50, '')).data.data.filter((x) => !!x.sage_id)
    const sectors_names = customer_data.industry_sector.map((x) => {
        let find = sector_list.find((y) => y.id === x)
        return find ? find.name : ""
    })

    const main_address = customer_data.addresses.find((x) => x.type === 'main')
    const sage_country_id = await getSageCountryId(main_address.country)
    const payload = {
        name: customer_data.company_name,
        reference: customer_data.account_number.match(/\d+/)[0],
        on_hold: false,
        telephone_country_code: customer_data.country_code_main_telephone,
        telephone_subscriber_number: customer_data.main_telephone,
        fax_country_code: customer_data.country_code_fax,
        fax_subscriber_number: customer_data.fax,
        website: customer_data.website,
        credit_limit: credit_details.credit_limit,
        payment_terms_days: customer_data.payment_terms ? customer_data.payment_terms : '0',
        terms_agreed: true,
        vat_number: customer_data.is_vat_registration_text || "",
        use_tax_code_as_default: true,
        // payment_terms_basis: 'Document Date',
        // default_tax_code_id: 0,
        // analysis_code_3: customer_data.account_handler || "N/A",
        // analysis_code_4: sectors_names.toString(),
        main_address: {
            address_1: main_address ? main_address.line1 : "",
            address_2: main_address ? main_address.line2 : "",
            address_3: main_address ? main_address.line3 : "",
            city: main_address ? main_address.town_state : "",
            country: main_address ? main_address.country : "",
            postcode: main_address ? main_address.post_code : "",
            address_country_code_id: sage_country_id
            
        },
        country_code_id: sage_country_id
    }
    // if (!!main_address) {
    //     const sage_country_codes = (await SageRepository.getCountryCodes()).data.data
    //     const find = sage_country_codes.find((x) => x.name === main_address.country)
    //     payload.main_address.address_country_code_id = find ? find.id : null
    //     payload.country_code_id = find ? find.id : null
    // }
    await SageRepository.updateSageCustomerDetails(customer_data.sage_id, payload)
    if (customer_users.length > 0) {
        for (let index = 0; index < customer_users.length; index++) {
            const contact = customer_users[index];
            await updateSageCustomerContact(customer_data.sage_id, contact)
        }
    }
}

export async function updateSageCustomerContact(customer_sage_id, data) {
    const contact = (await SageRepository.getCustomerContact(customer_sage_id, data.sage_id)).data.data
    const payload = {
        // user_id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        emails: [{ email: data.email, id: contact.emails.id }],
        telephones: [{ country_code: data.country_code_main_telephone, subscriber_number: data.main_telephone, id: contact.telephones.id }]
    }
    await SageRepository.updateSageCustomerContactDetails(customer_sage_id, data.sage_id, payload)
}

export async function updateSageRmSupplier(supplier_data) {
    const { data } = (await supplierManufactureRepository.getAllManufacturerSites(supplier_data.id)).data
    let payload = {
        name: supplier_data.company_name,
        // reference: supplier_data.account_number.match(/\d+/)[0],
        account_status_type: 'AccountStatusActive',
        telephone_country_code: supplier_data.country_code_telephone,
        telephone_subscriber_number: supplier_data.telephone,
        fax_country_code: supplier_data.country_code_fax,
        fax_subscriber_number:supplier_data.fax,
        vat_number: supplier_data.is_vat_registration_text,
    }
    if (data.length > 0) {
        const main_address = data[0]
        payload.main_address = {
            address_1: main_address ? main_address.address_line1 : "",
            address_2: main_address ? main_address.address_line2 : "",
            address_3: main_address ? main_address.address_line3 : "",
            city: main_address ? main_address.address_town_state : "",
            country: main_address ? main_address.address_country : "",
            postcode: main_address ? main_address.address_post_code : "",
            address_country_code_id: await getSageCountryId(main_address.address_country)
        }
    }
    await SageRepository.updateSageSupplierDetails(supplier_data.sage_id, payload)
}

export async function updateSageSupplier(supplier_data) {

    let payload = {
        name: supplier_data.company_name,
        reference: supplier_data.account_number ? supplier_data.account_number.match(/\d+/)[0] : '',
        account_status_type: 'AccountStatusActive',
        telephone_country_code: supplier_data.country_code_telephone,
        telephone_subscriber_number: supplier_data.telephone,
        fax_country_code: supplier_data.country_code_fax,
        fax_subscriber_number:supplier_data.fax,
        vat_number: supplier_data.is_vat_registration_text || ""
    }
    if (supplier_data.addresses.length > 0) {
        const main_address = supplier_data.addresses[0]
        const address = {
            address_1: main_address ? main_address.line1 : "",
            address_2: main_address ? main_address.line2 : "",
            address_3: main_address ? main_address.line3 : "",
            city: main_address ? main_address.town_state : "",
            country: main_address ? main_address.country : "",
            postcode: main_address ? main_address.post_code : "",
            address_country_code_id: await getSageCountryId(main_address.country)
        }
        payload.main_address = address
    }
    await SageRepository.updateSageSupplierDetails(supplier_data.sage_id, payload)
}

export async function createSageRmSupplier(supplier_data) {
    const { data } = (await supplierManufactureRepository.getAllManufacturerSites(supplier_data.id)).data
    let payload = {
        name: supplier_data.company_name,
        reference: supplier_data.account_number.match(/\d+/)[0],
        account_status_type: 'AccountStatusActive',
        telephone_country_code: supplier_data.country_code_telephone,
        telephone_subscriber_number: supplier_data.telephone,
        fax_country_code: supplier_data.country_code_fax,
        fax_subscriber_number:supplier_data.fax,
        vat_number: supplier_data.is_vat_registration_text,
    }
    if (data.length > 0) {
        const main_address = data[0]
        payload.main_address = {
            address_1: main_address ? main_address.address_line1 : "",
            address_2: main_address ? main_address.address_line2 : "",
            address_3: main_address ? main_address.address_line3 : "",
            city: main_address ? main_address.address_town_state : "",
            country: main_address ? main_address.address_country : "",
            postcode: main_address ? main_address.address_post_code : "",
            address_country_code_id: await getSageCountryId(main_address.address_country)
        }
    }
    await SageRepository.createSupplier(supplier_data.id, payload)
}

export async function updateSageSupplierContact(supplier_sage_id, data) {
    const contact = (await SageRepository.getSupplierContact(supplier_sage_id, data.sage_id)).data.data
    const payload = {
        // user_id: data.id,
        first_name: data.first_name,
        last_name: data.last_name,
        emails: [{ email: data.email, id: contact.emails.id }],
        telephones: [{ country_code: data.country_code_telephone, subscriber_number: data.telephone, id: contact.telephones.id }]
    }
    await SageRepository.updateSageSupplierContactDetails(supplier_sage_id, data.sage_id, payload)
}

async function getSageCountryId(country_name) {
    const country_codes = (await SageRepository.getCountryCodes()).data.data
    const system_country_codes = (await supplierManufactureRepository.getCountryCodes()).data.data

    const find_country_code = system_country_codes.find((x) => x.name === country_name)
    if(!find_country_code) return null
    const find_sage_country = country_codes.find((x) => x.code === find_country_code.iso_code)
    return find_sage_country ? find_sage_country.id : null
}